import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid, TextField } from '@mui/material';

import ColorPickerPopover from 'components/shared/ColorPickerPopover';

import { HexColor } from '../ColorPickerPopover/ColorPickerPopover';

function DutyCodeBaseFields() {
  const { t } = useTranslation('common');
  const { control, setValue } = useFormContext();

  const onColorSelect = (color: HexColor) => {
    setValue('colorCode', color);
  };

  return (
    <>
      <Grid container spacing={2.5} mb={2.5}>
        <Grid item xs={6}>
          <Controller
            name="displayDutyCode"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                fullWidth
                {...field}
                label={t('dutyCode')}
                inputProps={{
                  maxLength: 10
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                variant="outlined"
                size="small"
                required
              />
            )}
          />
        </Grid>
        <Grid item xs={6} mt={'4px'}>
          <Controller
            name="colorCode"
            control={control}
            render={({ field }) => (
              <ColorPickerPopover
                color={field.value}
                onColorSelected={onColorSelect}
                hasEditFeature={true}
                label={t('color')}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default DutyCodeBaseFields;
